import api from './api';

export const earlyWarningAPI = {
  getSummary: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/early-warning/summary/', { params }),

  getSchools: (params?: { academic_year?: string; district?: string }) =>
    api.get('/sis-integration/early-warning/schools/', { params }),

  getGenderAlerts: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/early-warning/gender-alerts/', { params }),
};
